<template>
  <div class="fixed top-8 z-[10000] w-full pointer-events-none text-newColors-gray-content">
    <div v-if="!isMobile" class="items-center justify-end container-small !pr-9 flex" :class="menuVisible && !isMobile ? '' : 'hidden'">
      <div class="relative !pointer-events-auto min-w-360">
        <ul class="mb-1 anchor-scroller-dynamic">
          <li class="mb-2 text-base font-futuraEfDemiBold">Innehåll</li>
          <li v-for="(item, index) in allHeadings" :key="index" class="relative flex mb-1">
            <a
              :href="`#${item.id}`"
              :class="linkInView[index] ? 'link-active font-futuraEfDemiBold no-underline text-newColors-green-primaryA' : ''"
              class="relative top-0.5 z-10 text-xl underline anchor-truncate underline-offset-2 decoration-1 text-newColors-green-primary hover:no-underline"
              :title="item.innerText">
              {{ item.innerText }}
            </a>
            <span v-if="linkInView[index]" class="active-anchor-background bg-newColors-gray-baseA"></span>
          </li>
        </ul>
        <div class="anchor-background"></div>
      </div>
    </div>

    <!-- mobile fixed menu -->
    <div v-if="isMobile" class="fixed top-0 w-full bg-white mobile-dynamic-menu !pointer-events-auto" :class="menuVisible && isMobile ? '' : 'hidden'">
      <p v-if="!isFolded" @click="closeDynamicContent" class="w-full cursor-pointer container-small min-h-[4rem] flex items-center bg-newColors-gray-baseA" role="button">Innehåll</p>
      <ul class="bg-white min-h-[4rem] relative anchor-scroller-dynamic border-b-1 border-newColors-gray-contentD" :class="isFolded ? 'mobile-dynamic-menu-shadow folded flex items-center' : ''">
        <li v-for="(item, index) in allHeadings" :key="index" class="flex mt-[1px]" :class="isFolded ? 'w-full' : 'bg-newColors-gray-background'">
          <a
            :href="`#${item.id}`"
            @click="toggleDynamicContent"
            :class="
              [
                linkInView[index] ? 'link-active ' : '',
                linkInView[index] && !isFolded ? 'bg-newColors-green-primaryA !text-white' : '',
                !linkInView[index] && !isFolded ? 'underline' : '',
                isFolded ? 'bg-newColors-gray-baseA flex items-center pl-5 absolute z-20 top-0 bottom-0 right-0 left-0' : 'block w-full relative anchor-truncate '
              ].join(' ')
            "
            class="z-10 text-xl decoration-1 container-small !ml-0"
            :title="isFolded ? item.innerText : ''">
            <span
              class="pointer-events-none"
              :class="
                [
                  linkInView[index] ? 'link-active  ' : '',
                  linkInView[index] && isFolded ? 'font-futuraEfDemiBold' : '',
                  isFolded ? '!max-w-[80%] leading-[1.375rem] line-clamp-2' : 'overflow-ellipsis',
                  linkInView[index] && !isFolded ? 'font-futuraEfDemiBold' : ''
                ].join(' ')
              "
              >{{ item.innerText }}</span
            >
          </a>
        </li>
      </ul>
      <button type="button" class="absolute right-0 z-30 mr-3 top-3.5 w-9 h-9 flex items-center justify-center pointer-events-none">
        <svg v-show="isFolded" xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 28 28">
          <path fill="#2C2827" fill-rule="evenodd" d="M12.405 12.411V1.595h3.19v24.808h-3.19V15.6l-10.81-.004V12.41h10.81Zm13.999 3.185h-8.261v-3.19h8.261v3.19Z" clip-rule="evenodd" />
        </svg>
        <svg v-show="!isFolded" xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 28 28">
          <path fill="#2C2827" d="M26.402 15.595H1.596v-3.19h24.808v3.19Z" />
        </svg>
      </button>
    </div>
  </div>
  <div v-show="isMobile && !this.isFolded" class="absolute top-0 bottom-0 left-0 right-0 z-[80] anchor-blur-bg"></div>
</template>

<script>
export default {
  name: 'ellevio-web-scroll-trigger-list',
  data() {
    return {
      isFolded: true,
      isMobile: true,
      menuVisible: false,
      observer: [],
      linkInView: [],
      allHeadings: null,
      endOfPageAtFeedback: null,
      endOfPageAtEndDynamicMenuBlock: null,
      endOfPageAtFooter: null,
      scrollTriggerSelector: 'h2[id^="h-"]',
      endOfPageFeedbackSelector: '.vue-feedback-form',
      endOfPageSelector: '.end-dynamic-menu-block',
      footerSelector: 'footer',
      reducedMotion: false,
      dynamicMenuHeight: 0
    }
  },
  computed: {
    matchMediaQuery() {
      return window.matchMedia(' (max-width: 1160px) ')
    }
  },
  methods: {
    toggleDynamicContent(event) {
      if (this.isFolded) {
        this.isFolded = !this.isFolded
        event.preventDefault()
        this.lockScroll()
      } else {
        this.openScroll()
        this.isFolded = !this.isFolded
      }
    },
    lockScroll() {
      const bodyClassNames = ['overflow-hidden']

      if (!document.body.classList.contains(bodyClassNames[0])) {
        document.body.classList.add(...bodyClassNames)
      }
    },
    openScroll() {
      const bodyClassNames = ['overflow-hidden']
      if (document.body.classList.contains(bodyClassNames[0])) {
        document.body.classList.remove(...bodyClassNames)
      }
    },
    closeDynamicContent() {
      this.isFolded = true
      this.openScroll()
    },
    resize: function () {
      this.isMobile = this.matchMediaQuery.matches ? true : false
    },
    createStaticMenu() {
      let wysiwygNode = document.querySelector('.wysiwyg')
      let staticMenuAlreadyExist = document.querySelectorAll('.anchor-scroller').length > 0
      if (wysiwygNode && !staticMenuAlreadyExist) {
        let parentNode = wysiwygNode.parentNode
        let newNode = document.createElement('ul')
        newNode.classList.add('mb-20', 'anchor-scroller', 'relative', 'ml-2.5')
        let titleLi = document.createElement('li')
        titleLi.innerText = 'Innehåll'
        titleLi.classList.add('mb-2', 'text-base', 'font-futuraEfDemiBold')
        newNode.appendChild(titleLi)
        this.allHeadings.forEach((el) => {
          let li = document.createElement('li')
          li.classList.add('flex', 'mb-1')
          let a = document.createElement('a')
          a.innerText = el.innerText
          a.setAttribute('href', `#${el.id}`)
          a.setAttribute('title', el.innerText)
          a.classList.add('text-xl', 'underline', 'anchor-truncateLong', 'underline-offset-2', 'decoration-1', 'text-newColors-green-primary', 'hover:no-underline')
          li.appendChild(a)
          newNode.appendChild(li)
        })
        parentNode.insertBefore(newNode, wysiwygNode)
      }
    },
    wrapElements() {
      const scrollTriggers = document.querySelectorAll(this.scrollTriggerSelector)

      for (let i = 0; i < scrollTriggers.length; i++) {
        const wrapper = document.createElement('div')
        wrapper.classList.add('scroll-trigger-wrapper')
        scrollTriggers[i].parentNode.insertBefore(wrapper, scrollTriggers[i])
        wrapper.appendChild(scrollTriggers[i])

        const menuPixelDown = document.createElement('span')
        menuPixelDown.classList.add('menu-pixel-down')
        wrapper.appendChild(menuPixelDown)

        if (i !== 0) {
          const menuPixelUp = document.createElement('span')
          menuPixelUp.classList.add('menu-pixel-up')
          wrapper.appendChild(menuPixelUp)
        }
      }
    },
    checkMenuVisibility() {
      //first show the menu near first relevant heading, h2 with id starting with "h-". We are assuming this is right after the static menu.
      const topElementPos = document.querySelectorAll('.menu-pixel-down')[0].getBoundingClientRect().top
      const elementFeedback = this.endOfPageAtFeedback
      const elementEndDynamicMenuBlock = this.endOfPageAtEndDynamicMenuBlock

      //hide the menu at the feedback form or no such block exist on page, then remove the menu when close to the footer
      const boundary = elementEndDynamicMenuBlock?.getBoundingClientRect().top + 175 || elementFeedback?.getBoundingClientRect().top || this.endOfPageAtFooter.getBoundingClientRect().top

      let menuBoundary = this.isMobile ? 210 : this.dynamicMenuHeight + 260

      if (boundary <= menuBoundary || topElementPos > 0) {
        this.menuVisible = false
      } else {
        this.menuVisible = true
      }
    },
    checkLinksPosition() {
      const menuPixelDown = document.querySelectorAll('.menu-pixel-down')
      //const menuPixelUp = document.querySelectorAll('.menu-pixel-up')

      for (let i = 0; i < menuPixelDown.length; i++) {
        const topElementPos = menuPixelDown[i].getBoundingClientRect().top
        //const bottomElementPos = menuPixelUp[i]?.getBoundingClientRect().bottom

        if (topElementPos < 0) {
          for (let j = 0; j < this.linkInView.length; j++) {
            this.linkInView[j] = false
          }
          this.linkInView[i] = true
        }
      }
    },
    runScollTriggers() {
      if (!this.isMobile) {
        // Add the scroll event listener, checking when links should be active (mobile)
        const menuPixelDown = document.querySelectorAll('.menu-pixel-down')

        for (let i = 0; i < menuPixelDown.length; i++) {
          const menuPixelDownObserver = new IntersectionObserver(
            ([entry]) => {
              let isScrollingUpwards = true
              const isIntersectingAtTop = entry.boundingClientRect.top < 140

              if (isIntersectingAtTop) {
                if (entry.isIntersecting) {
                  isScrollingUpwards = true
                  // entered viewport at the top edge, hence scroll direction is up
                } else {
                  isScrollingUpwards = false
                  // left viewport at the top edge, hence scroll direction is down
                }
              }

              if (!isScrollingUpwards && isIntersectingAtTop) {
                for (let j = 0; j < this.linkInView.length; j++) {
                  this.linkInView[j] = false
                }
                this.linkInView[i] = true
              }
            },
            {
              root: null,
              rootMargin: '-20px',
              threshold: [0, 1]
            }
          )

          menuPixelDownObserver.observe(menuPixelDown[i])
        }

        const menuPixelUp = document.querySelectorAll('.menu-pixel-up')

        for (let i = 0; i < menuPixelUp.length; i++) {
          const menuPixelUpObserver = new IntersectionObserver(
            ([entry]) => {
              const isIntersectingAtTop = entry.boundingClientRect.top < 140
              let isScrollingUpwards = false
              if (isIntersectingAtTop) {
                if (entry.isIntersecting) {
                  isScrollingUpwards = true
                  // entered viewport at the top edge, hence scroll direction is up
                } else {
                  isScrollingUpwards = false
                  // left viewport at the top edge, hence scroll direction is down
                }
              }
              if (isScrollingUpwards && isIntersectingAtTop) {
                for (let j = 0; j < this.linkInView.length; j++) {
                  this.linkInView[j] = false
                }
                this.linkInView[i] = true
              }
            },
            {
              root: null,
              rootMargin: '-20px',
              threshold: [0, 1]
            }
          )

          menuPixelUpObserver.observe(menuPixelUp[i])
        }
      }

      if (document.querySelectorAll('.menu-pixel-down').length > 0) {
        // Add the scroll event listener, checking if/when the menu should be visible
        window.addEventListener('scroll', this.checkMenuVisibility)
        // Add the scroll event listener, checking when links should be active (mobile)
        if (this.isMobile) window.addEventListener('scroll', this.checkLinksPosition)
      }
    }
  },
  mounted() {
    //a way to check for reduced motion
    this.reducedMotion = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true
    const htmlClassNames = ['smooth-scroll']

    this.isMobile = this.matchMediaQuery.matches ? true : false
    this._boundedResize = this.resize.bind(this)
    window.addEventListener('resize', this._boundedResize)

    this.allHeadings = document.querySelectorAll(this.scrollTriggerSelector)

    if (this.allHeadings.length > 1) {
      //if reducedMotion selected, add smooth scrolling to this page only, not globally
      if (this.reducedMotion) {
        document.documentElement.classList.add(...htmlClassNames)
      }
      this.$nextTick(() => {
        this.endOfPageAtFeedback = document.querySelector(this.endOfPageFeedbackSelector)
        this.endOfPageAtEndDynamicMenuBlock = document.querySelector(this.endOfPageSelector)
        const footerSelectorArray = document.querySelectorAll(this.footerSelector)
        this.endOfPageAtFooter = footerSelectorArray[footerSelectorArray.length - 1]
        this.dynamicMenuHeight = this.allHeadings.length * 28 + 15

        this.createStaticMenu()
        this.wrapElements()
        this.runScollTriggers()
      })
    }
  }
}
</script>
<style>
.anchor-truncate,
.anchor-truncateLong {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
}
.anchor-truncate {
  max-width: 360px;
}
.anchor-truncateLong {
  max-width: 660px;
}

.mobile-dynamic-menu .anchor-truncate {
  max-width: none;
}

.anchor-blur-bg {
  background: rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(4px);
}

.anchor-scroller-dynamic:before {
  background-color: white;
}

.anchor-scroller:before {
  content: '';
  position: absolute;
  left: -10px;
  width: 2px;
  height: calc(100% + 4px);
}

@media (min-width: 1161px) {
  .anchor-scroller-dynamic:before,
  .anchor-scroller-dynamic li:not(:first-child):hover:before,
  .anchor-scroller-dynamic li:has(.link-active):before {
    content: '';
    position: absolute;
    left: -10px;
    width: 2px;
    height: calc(100% + 4px);
  }
  .anchor-scroller-dynamic:before {
    background-color: #e5e3e1;
    height: 100%;
  }
  .anchor-scroller-dynamic li:not(:first-child):hover:before {
    background-color: #0b8454;
  }
  .anchor-scroller-dynamic li:has(.link-active):before {
    background-color: #0f5a46;
  }
}

.anchor-scroller:before {
  background-color: #0b8454;
}
.menu-pixel-down,
.menu-pixel-up {
  position: absolute;
  left: -1px;
  width: 1px;
  height: 1px;
  background-color: transparent;
}
.menu-pixel-down {
  top: -84px;
}
.menu-pixel-up {
  top: -109px;
}
@media (min-width: 1161px) {
  .menu-pixel-down {
    top: -20px;
  }
  .menu-pixel-up {
    top: -45px;
  }
}
.scroll-trigger-wrapper {
  position: relative;
}
.anchor-background {
  background-color: white;
  border-radius: 12px;
  position: absolute;
  top: -20px;
  bottom: -20px;
  left: -26px;
  right: -16px;
  z-index: -1;
}
.active-anchor-background {
  position: absolute;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  z-index: 1;
  top: 0;
  bottom: -4px;
  left: -8px;
  right: 0;
}
.mobile-dynamic-menu-shadow {
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.05);
}
.mobile-dynamic-menu ul.folded li:has(:not(.link-active)) {
  display: none;
}
h2[id^='h-'] {
  padding-top: 10px;
  margin-top: -10px;
  scroll-margin-top: 64px;
}
@media (min-width: 1161px) {
  h2[id^='h-'] {
    scroll-margin-top: 0;
  }
}
</style>
